import Event from '@oppobrowser/lib-browser-event';
import EventEmit from '@oppobrowser/lib-browser-eventEmit';
import template from './index.dot';
import './index.scss';
import { getHeaderKKUA, getSession } from '@js/native';
import { stat } from '../../js/utils';
import { asyncLoadJs, getNetworkType } from '@js/utils';
import {
  query,
  browserPartner,
  buuid,
  stat_id,
  channel,
  isNewPush,
  isInfinity,
} from '../../js/constants';
import { BrowserBridgeHandler } from '../../js/browserBridgeHandler';

const EventHandler = {};

const videoTypeMap = {
  2: 'shortVideo',
  5: 'smallVideo',
};

export default class RelatedReading {
  constructor(el) {
    this.el = el;
    this._eventHandler = {};
    this._data = {};
  }
  init() {
    this.initEvent();
  }
  initEvent() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);

    EventEmit.instance.on('showMore', () => {
      this.recalcVideoNodePos();
    });

    EventEmit.instance.on('ad-close', () => {
      this.recalcVideoNodePos();
    });

    EventEmit.instance.on('ad-loaded', () => {
      this.recalcVideoNodePos();
    });

    EventEmit.instance.on('ad-resize', () => {
      this.recalcVideoNodePos();
    });

    EventEmit.instance.on('ad-loaded-callback', () => {
      this.recalcVideoNodePos();
    });
  }

  // 重新计算视频节点位置
  recalcVideoNodePos() {
    window.newsFlowRecalcVideoNodePos && window.newsFlowRecalcVideoNodePos();
  }

  async initNews() {
    // // 获取header头数据
    // const kkuaHeader = await getHeaderKKUA();
    // // 获取session
    // const session = await getSession();
    // // 调用客户端方法获取feedssession
    // const { loginSession } = window.store;
    // const { uid, uuid, sourceVal } = window.store;
    // const docInfo = window.pageData.DOCINFO;
    const { sourceVal } = window.store;

    const newsFlowUrl =
      window.pageData?.newsUrl?.newsFlowUrl ||
      '//static-cpc.heytapimage.com/front-common-lib/lib-browser-news-flow/release/lib-browser-news-flow.umd-min.js';
    const tasks = [asyncLoadJs(newsFlowUrl)];

    Promise.all(tasks)
      .then(() => {
        window.newsFlowInject({
          id: 'related-news-flow-container', // 容器
          env: window.pageData.newsUrl.env, // 信息流接口环境, 正式:pro 测试:test
          params: {
            source: sourceVal,
          },
          docInfo: {
            title: window.pageData?.DOCINFO?.title,
          },
          custom: {
            videoAutoPlay: window.modulesConfig?.relatedNewsFlow?.videoAutoPlay,
            videoAutoPlayNoWifi:
              window.modulesConfig?.relatedNewsFlow?.videoAutoPlayNoWifi,
          },
        });
      })
      .catch((error) => {
        console.error('push无限流加载出错', error);
      });
  }

  render() {
    this.el.innerHTML = template({});
    this.initNews();
    EventEmit.instance.emit('component-loaded', 'relatedNewsFlow', {});
  }
}
